import { useCallback } from "react";
import { confirm } from "../ConfirmDialog";
import { useRuntime } from "@/ui/contexts/RuntimeProvider";
import { useScope } from "@/ui/contexts/ScopeContext";

export const useGraphNode = (instanceId: string, nodeId: string) => {
  const { deleteNode } = useRuntime();
  const { definitionState } = useScope();

  const tryDelete = useCallback(async () => {
    const connections = definitionState?.connections ?? {};

    // Count connections to this node
    const connectionCount = Object.values(connections).filter(
      conn => conn.source.startsWith(nodeId + '.') || conn.target.startsWith(nodeId + '.')
    ).length;

    // If no connections, delete immediately
    if (connectionCount === 0) {
      deleteNode(instanceId, nodeId);
      return;
    }

    // Show confirmation for nodes with connections
    const confirmed = await confirm({
      title: `Delete "${nodeId}"?`,
      message: `This node has ${connectionCount} connection${connectionCount === 1 ? '' : 's'} that will be removed.`,
      confirmLabel: 'Delete'
    });
    if (confirmed) deleteNode(instanceId, nodeId);
  }, [instanceId, nodeId, definitionState?.connections, deleteNode]);

  return { tryDelete };
}